<template>
  <div class="app-container">
        <el-card class="card" :style="{ width: isMobile ? '100%' : '95%' }">
          <h2 style="text-align: center">如何设置{{ title }}为浏览器主页？</h2>
          <p style="text-align: center">
            如果你喜欢{{ title }}，欢迎设置{{
              title
            }}为你的浏览器主页。推荐设置为浏览器主页
          </p>
          <el-collapse accordion style="margin-top: 50px">
            <el-collapse-item>
              <template #title>
                <el-image
                  class="image-type"
                  lazy
                  :src="getPictureShowUrl('/profile/images/chrome.png')"
                ></el-image
                >谷歌浏览器
              </template>
              <div>
                <p>1、点击右上角的设置</p>
                <el-image
                  :src="
                    getPictureShowUrl('/profile/images/setIndex/google-1.png')
                  "
                ></el-image>
                <p>
                  2、点击左侧的【启动时】，然后点击中间的【打开特定网页或一组网页】，接着点击【添加新网页】
                </p>
                <el-image
                  :src="
                    getPictureShowUrl('/profile/images/setIndex/google-2.png')
                  "
                ></el-image>
                <p>3、在弹出框中，输入 {{ getHost() }}，然后点击【添加】</p>
                <el-image
                  :src="
                    getPictureShowUrl('/profile/images/setIndex/google-3.png')
                  "
                ></el-image>
                <p>4、这时，看到如下所示，表示设置成功。重启浏览器即可生效！</p>
                <el-image
                  :src="
                    getPictureShowUrl('/profile/images/setIndex/google-4.png')
                  "
                ></el-image>
              </div>
            </el-collapse-item>
            <el-collapse-item>
              <template #title>
                <el-image
                  class="image-type"
                  lazy
                  :src="getPictureShowUrl('/profile/images/edge.png')"
                ></el-image
                >Edge浏览器
              </template>
              <p>1、点击右上角的设置</p>
              <el-image
                :src="getPictureShowUrl('/profile/images/setIndex/edge-1.png')"
              ></el-image>
              <p>
                2、点击左侧的【启动时】，然后点击中间的【打开一个或多个特定页面】，接着点击【添加新页面】
              </p>
              <el-image
                :src="getPictureShowUrl('/profile/images/setIndex/edge-2.png')"
              ></el-image>
              <p>3、在弹出框中，输入 {{ getHost() }}，然后点击【添加】</p>
              <el-image
                :src="getPictureShowUrl('/profile/images/setIndex/edge-3.png')"
              ></el-image>
              <p>4、这时，看到如下所示，表示设置成功。重启浏览器即可生效！</p>
              <el-image
                :src="getPictureShowUrl('/profile/images/setIndex/edge-4.png')"
              ></el-image>
            </el-collapse-item>
            <el-collapse-item>
              <template #title>
                <el-image
                  class="image-type"
                  lazy
                  :src="getPictureShowUrl('/profile/images/360.png')"
                ></el-image
                >360安全浏览器
              </template>
              <p>1、点击右上角的设置</p>
              <el-image
                :src="getPictureShowUrl('/profile/images/setIndex/360-1.png')"
              ></el-image>
              <p>
                2、点击左侧的【基本设置】，拉到底部，然后点击中间的【修改主页】
              </p>
              <el-image
                :src="getPictureShowUrl('/profile/images/setIndex/360-2.png')"
              ></el-image>
              <p>3、在弹出框中，输入 {{ getHost() }}，然后点击【确定】</p>
              <el-image
                :src="getPictureShowUrl('/profile/images/setIndex/360-3.png')"
              ></el-image>
              <p>4、这时，看到如下所示，表示设置成功。重启浏览器即可生效！</p>
              <el-image
                :src="getPictureShowUrl('/profile/images/setIndex/360-4.png')"
              ></el-image>
            </el-collapse-item>
            <el-collapse-item>
              <template #title>
                <el-image
                  class="image-type"
                  lazy
                  :src="getPictureShowUrl('/profile/images/360js.png')"
                ></el-image
                >360极速浏览器
              </template>
              <p>1、点击右上角的设置图标，选择【设置界面样式】</p>
              <el-image
                :src="getPictureShowUrl('/profile/images/setIndex/360js-1.png')"
              ></el-image>
              <p>
                2、点击左侧的【基本设置】，在打开主页的输入框输入
                {{ getHost() }}。重启浏览器即可生效！
              </p>
              <el-image
                :src="getPictureShowUrl('/profile/images/setIndex/360js-2.png')"
              ></el-image>
            </el-collapse-item>
            <el-collapse-item>
              <template #title>
                <el-image
                  class="image-type"
                  lazy
                  :src="getPictureShowUrl('/profile/images/firefox.png')"
                ></el-image
                >Firefox浏览器
              </template>
              <p>1、点击右上角的设置图标，选择【选项】</p>
              <el-image
                :src="
                  getPictureShowUrl('/profile/images/setIndex/firefox-1.png')
                "
              ></el-image>
              <p>
                2、点击左侧的【主页】，在主页和窗口中，输入
                {{ getHost() }}。重启浏览器即可生效！
              </p>
              <el-image
                :src="
                  getPictureShowUrl('/profile/images/setIndex/firefox-2.png')
                "
              ></el-image>
            </el-collapse-item>
          </el-collapse>

          <div class="bottom-question">
            设置中遇到问题可联系<span class="concat">{{ setIndexConcat }}</span
            >进行协助，感谢您对{{ title }}的支持。
          </div>
        </el-card>
  </div>
</template>
<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'

import { title, setIndexConcat } from '@/config/setting.config'
import { getPictureShowUrl, getHost } from '@/utils/geshanzsq'
import { useDefaultClientCategories } from '@/composables/useDefaultClientCategories'

const store = useStore()
const setDefaultCategories = useDefaultClientCategories()

// 是否移动端
const isMobile = computed(() => store.getters['app/isMobile'])

// 设为首页页没有专属分类接口，使用默认导航分类填充左侧栏
setDefaultCategories()
</script>
<style scoped lang="scss">
.card {
  margin: auto;
  .image-type {
    height: 35px;
    width: 35px;
    overflow: hidden;
    margin-right: 10px;
  }

  .bottom-question {
    margin-top: 20px;
    text-align: center;
    font-size: 15px;
    color: #5e5d5d;
    .concat {
      font-weight: bold;
    }
  }
}
</style>
